/**
 * interfaces
 */
import { IUnitListItemModel } from './interfaces';
import { IUnitListItemDto } from '../../interfaces';

/**
 * View model for a unit below a building (GET units/list/{buildingId}).
 *
 * Wraps the raw {@link IUnitListItemDto} and exposes every field as a
 * camelCase getter.
 */
export class UnitListItemModel implements IUnitListItemModel {

    /**
     * @param dto - Raw unit list item DTO from the API.
     */
    constructor(public readonly dto: IUnitListItemDto) {}

    /** @inheritdoc */
    public get id(): string {
        return this.dto.id;
    }

    /** @inheritdoc */
    public get name(): string {
        return this.dto.name;
    }

    /** @inheritdoc */
    public get level(): number {
        return this.dto.level;
    }

    /** @inheritdoc */
    public get parentId(): string | null {
        return this.dto.parent_id;
    }

    /** @inheritdoc */
    public get hasMeters(): boolean {
        return this.dto.has_meters;
    }

    /** @inheritdoc */
    public get isBuilding(): boolean {
        return this.dto.is_building;
    }

    /** @inheritdoc */
    public get typeId(): string {
        return this.dto.type_id;
    }

    /** @inheritdoc */
    public get typeName(): string {
        return this.dto.unit_type_name;
    }

}
